/*
 * Copyright (C) 2018 BarD Software s.r.o
 */

import { addDays, format, formatDistanceToNow, isBefore } from 'date-fns';

export function timestampString(ts: number): string {
    return format(new Date(ts), 'PPPpp');
}

export function dateString(ts: number): string {
    return format(new Date(ts), 'PPP');
}

export interface GPTime {
    str: string;
    relative: boolean;
}

export function timestampAdaptiveString(ts: number): GPTime {
    return isBefore(addDays(new Date(), -1), ts)
      ? { str: `${formatDistanceToNow(new Date(ts))} ago`, relative: true }
      : { str: timestampString(ts), relative: false };
}
